import { GeneralObject, StringObject } from "../definitions/general";

export const getModifiedKeys = (
  reference: GeneralObject,
  updatedObject: GeneralObject
) => {
  let changes: GeneralObject = {};
  for (const refKey in reference) {
    if (Object.prototype.hasOwnProperty.call(reference, refKey)) {
      const refValue = reference[refKey];
      const modifiedValue = updatedObject[refKey];
      if (
        refValue !== undefined &&
        modifiedValue !== undefined &&
        !(refValue == null && modifiedValue === "") &&
        JSON.stringify(refValue) !== JSON.stringify(modifiedValue)
      ) {
        changes[refKey] = modifiedValue;
      }
    }
  }

  return Object.keys(changes).length > 0 ? changes : {};
};

export const getObjectWithPrefixedKeys: (
  obj: StringObject,
  prefix: string
) => StringObject = (obj, prefix) => {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      obj[key] = prefix + obj[key];
    }
  }

  return obj;
};

export const TYPE_MAP: GeneralObject = {
  zostel: "H",
  homes: "B",
  campsites: "C",
  resorts: "F",
  hotels: "R",
  "trusted-by-zostel": "T",
  house: "HO",
};
export const REVERSE_TYPE_MAP: GeneralObject = {
  H: "zostel",
  B: "homes",
  C: "campsites",
  F: "resorts",
  R: "hotels",
  T: "trusted-by-zostel",
  HO: "house",
};
